import i18n from 'i18next';
import getOr from 'lodash/fp/getOr';
import { flow } from 'lodash-es';
import qs from 'query-string';
import { initReactI18next } from 'react-i18next';

import * as en from './en';
import * as ja from './ja';
import * as th from './th';
import * as vi from './vi';
import * as zhCn from './zhCn';
import * as zhHant from './zhHant';

export const DEFAULT_LANG = 'en';

const parseLocale = flow(qs.parse, getOr(DEFAULT_LANG, 'locale'));

export const resources = {
  'zh-hant': zhHant,
  'zh-cn': zhCn,
  vi,
  th,
  ja,
  en,
};

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  resources,
  lowerCaseLng: true,
  lng: parseLocale(window.location.search) as string,
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
  initImmediate: false,
});

export default i18n;
